import { render, staticRenderFns } from "./NewsFeaturedCard.vue?vue&type=template&id=c8a61984"
import script from "./NewsFeaturedCard.vue?vue&type=script&lang=js"
export * from "./NewsFeaturedCard.vue?vue&type=script&lang=js"
import style0 from "./NewsFeaturedCard.vue?vue&type=style&index=0&id=c8a61984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports